<script lang="ts">
  import type { Meta } from "types/backend/models/cms/meta.entity";
  import { hasHttp } from "./meta-utils";
  import { utils } from "$lib/utils";
  const PUBLIC_URL = utils.getHost();

  export let meta: Meta;
  $: ({ rel, hreflang, href } = meta);
</script>

<svelte:head>
  {#if href}
    {@const validHref = hasHttp(href) ? href : `${PUBLIC_URL}${utils.slugify(href)}`}
    {#if rel === "canonical"}
      <link rel="canonical" href={validHref} />
    {:else if href && hreflang}
      <link rel="alternate" hrefLang={hreflang} href={validHref} />
    {/if}
  {/if}
</svelte:head>
